import { GlobeHemisphereWest } from "@phosphor-icons/react";
import { useI18n } from "../i18n";

export function LanguageSwitch({ minimal = false }: { minimal?: boolean }) {
  const { locale, setLocale } = useI18n();
  return (
    <div className={`language-switch${minimal ? " language-switch--minimal" : ""}`}>
      <GlobeHemisphereWest aria-hidden="true" size={16} weight="regular" />
      <button
        aria-pressed={locale === "en"}
        className={locale === "en" ? "is-active" : undefined}
        onClick={() => setLocale("en")}
        type="button"
      >
        EN
      </button>
      <span aria-hidden="true">/</span>
      <button
        aria-pressed={locale === "zh"}
        className={locale === "zh" ? "is-active" : undefined}
        onClick={() => setLocale("zh")}
        type="button"
      >
        中文
      </button>
    </div>
  );
}
